// extracted by mini-css-extract-plugin
export default {"pageContent":"PageContent_pageContent__KWbPz","content":"PageContent_content__NJbOg"};